// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-render-marker {
    width: 25px;
    height: 25px;
    /* background-color: red; */
    margin-bottom: 10px;
    /* Google Maps marker color */
    border-radius: 50% 50% 50% 0;
    position: relative;
    transform: rotate(-45deg);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.map-render-marker::after {
    content: "";
    width: 21.5px;
    height: 21.5px;
    background-color: white;
    border-radius: 50%;
    position: absolute;
    top: 49%;
    left: 49%;
    transform: translate(-50%, -50%);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);


}

.absolute-render-center {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    left: 48%;
    top: 35%;
    transform: translate(-50%, -50%);
    width: 30px;
    /* Adjust width as needed */
    height: 25px;
    /* Adjust height as needed */
    z-index: 1;
}

.container {
    position: relative;
    width: 35px;
    height: 35px;
    /* margin: 15px; */

}

/* .outer-circle {
    width: 90%;
    height: 90%;
    border-radius: 50%;
    position: absolute;
}

.inner-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90%;
    height: 90%;
    border-radius: 50%;
    position: absolute;
} */


.outer-circle {
    width: 90%;
    height: 90%;
    border-radius: 50%;
    position: relative;
    /* Change to relative position */
    background-color: lightgray;
    /* Optional: Add background color for clarity */
}

.inner-circle {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90%;
    height: 90%;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.image {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
    margin: 0;
    /* Add margin: 0; to remove any default margin */
}


.triangle-style {
    position: absolute;
    bottom: 0px;
    left: 34%;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    z-index: -1;
    /* Ensure triangle is above the circles */
}

.container-mouse-handler {
    position: relative;
    width: 35px;
    height: 35px;
    margin: 2px;
}

.outer-circle-mouse-handler {
    width: 90%;
    height: 90%;
    border-radius: 50%;
    position: relative;
    /* Change to relative position */
    background-color: lightgray;
    /* Optional: Add background color for clarity */
}

.inner-circle-mouse-handler {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90%;
    height: 90%;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.image-mouse-handler {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
    margin: 0;
}

.triangle-style-mouse-handler {
    position: absolute;
    /* bottom: 5px; */
    bottom: -2px;
    left: 10px;
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    z-index: -1;
}

.camera-icon-border {
    width: 30px;
    height: 30px;
    border-radius: 5px;
    border: 2px solid #589500;
    opacity: 1;
    display: flex;
    justify-content: center;
    align-items: center;

}

.juBESy {
    height: 100% !important;
    position: relative;
    width: 100% !important;
}

.image-color-change {
    width: 330px;
    height: 240px;
    opacity: 1;
}

.file-drop-target-image {
    width: 100%;
    height: 100%;
    border-radius: 5px;
    box-sizing: border-box;
}

.heading-bar {

    text-align: left;
    font: normal normal bold 30px/39px Roboto;
    letter-spacing: 0px;
    color: #EBEBEB;
    opacity: 1;
}

.gm-style {
    visibility: visible !important;
}

.custom-alert {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border: 1px solid #ccc;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    padding: 20px;
    height: 200px;
    width: 200px;
    max-width: 300px;
    z-index: 111;
}

.custom-alert-content {
    position: relative;
}

.close-btn {
    position: absolute;
    top: 5px;
    right: 5px;
    font-size: 20px;
    cursor: pointer;
}

.close-btn {
    cursor: pointer;
    position: absolute;
    top: 5px;
    right: 5px;
    font-size: 20px;
    color: #333;
}

.close-btn:hover {
    color: #555;
}

.gm-style-iw {
    visibility: visible;
}

.photo-property {
    width: 35px;
    height: 40px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/component/map/render-photos/photo.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,mBAAmB;IACnB,6BAA6B;IAC7B,4BAA4B;IAC5B,kBAAkB;IAClB,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,wCAAwC;;;AAG5C;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,WAAW;IACX,2BAA2B;IAC3B,YAAY;IACZ,4BAA4B;IAC5B,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;;AAEtB;;AAEA;;;;;;;;;;;;;;;GAeG;;;AAGH;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,gCAAgC;IAChC,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;IACT,gDAAgD;AACpD;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,WAAW;IACX,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,gCAAgC;IAChC,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,UAAU;IACV,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;;IAEI,gBAAgB;IAChB,yCAAyC;IACzC,mBAAmB;IACnB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,sBAAsB;IACtB,sBAAsB;IACtB,uCAAuC;IACvC,aAAa;IACb,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":[".map-render-marker {\n    width: 25px;\n    height: 25px;\n    /* background-color: red; */\n    margin-bottom: 10px;\n    /* Google Maps marker color */\n    border-radius: 50% 50% 50% 0;\n    position: relative;\n    transform: rotate(-45deg);\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.map-render-marker::after {\n    content: \"\";\n    width: 21.5px;\n    height: 21.5px;\n    background-color: white;\n    border-radius: 50%;\n    position: absolute;\n    top: 49%;\n    left: 49%;\n    transform: translate(-50%, -50%);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n\n\n}\n\n.absolute-render-center {\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    left: 48%;\n    top: 35%;\n    transform: translate(-50%, -50%);\n    width: 30px;\n    /* Adjust width as needed */\n    height: 25px;\n    /* Adjust height as needed */\n    z-index: 1;\n}\n\n.container {\n    position: relative;\n    width: 35px;\n    height: 35px;\n    /* margin: 15px; */\n\n}\n\n/* .outer-circle {\n    width: 90%;\n    height: 90%;\n    border-radius: 50%;\n    position: absolute;\n}\n\n.inner-circle {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 90%;\n    height: 90%;\n    border-radius: 50%;\n    position: absolute;\n} */\n\n\n.outer-circle {\n    width: 90%;\n    height: 90%;\n    border-radius: 50%;\n    position: relative;\n    /* Change to relative position */\n    background-color: lightgray;\n    /* Optional: Add background color for clarity */\n}\n\n.inner-circle {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 90%;\n    height: 90%;\n    border-radius: 50%;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.image {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    object-fit: cover;\n    margin: 0;\n    /* Add margin: 0; to remove any default margin */\n}\n\n\n.triangle-style {\n    position: absolute;\n    bottom: 0px;\n    left: 34%;\n    width: 0;\n    height: 0;\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n    z-index: -1;\n    /* Ensure triangle is above the circles */\n}\n\n.container-mouse-handler {\n    position: relative;\n    width: 35px;\n    height: 35px;\n    margin: 2px;\n}\n\n.outer-circle-mouse-handler {\n    width: 90%;\n    height: 90%;\n    border-radius: 50%;\n    position: relative;\n    /* Change to relative position */\n    background-color: lightgray;\n    /* Optional: Add background color for clarity */\n}\n\n.inner-circle-mouse-handler {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 90%;\n    height: 90%;\n    border-radius: 50%;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.image-mouse-handler {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    object-fit: cover;\n    margin: 0;\n}\n\n.triangle-style-mouse-handler {\n    position: absolute;\n    /* bottom: 5px; */\n    bottom: -2px;\n    left: 10px;\n    width: 0;\n    height: 0;\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    z-index: -1;\n}\n\n.camera-icon-border {\n    width: 30px;\n    height: 30px;\n    border-radius: 5px;\n    border: 2px solid #589500;\n    opacity: 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n}\n\n.juBESy {\n    height: 100% !important;\n    position: relative;\n    width: 100% !important;\n}\n\n.image-color-change {\n    width: 330px;\n    height: 240px;\n    opacity: 1;\n}\n\n.file-drop-target-image {\n    width: 100%;\n    height: 100%;\n    border-radius: 5px;\n    box-sizing: border-box;\n}\n\n.heading-bar {\n\n    text-align: left;\n    font: normal normal bold 30px/39px Roboto;\n    letter-spacing: 0px;\n    color: #EBEBEB;\n    opacity: 1;\n}\n\n.gm-style {\n    visibility: visible !important;\n}\n\n.custom-alert {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: #fff;\n    border: 1px solid #ccc;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    padding: 20px;\n    height: 200px;\n    width: 200px;\n    max-width: 300px;\n    z-index: 111;\n}\n\n.custom-alert-content {\n    position: relative;\n}\n\n.close-btn {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    font-size: 20px;\n    cursor: pointer;\n}\n\n.close-btn {\n    cursor: pointer;\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    font-size: 20px;\n    color: #333;\n}\n\n.close-btn:hover {\n    color: #555;\n}\n\n.gm-style-iw {\n    visibility: visible;\n}\n\n.photo-property {\n    width: 35px;\n    height: 40px;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
